import React from "react";
import Popup from "reactjs-popup";
import { ReactComponent as Info } from "../../../images/info.svg";
import { cn } from "../../../services/common/className";
import "reactjs-popup/dist/index.css";
import "./legend.scss";

export interface LegendProps {
  mix?: string;
  children: React.ReactElement;
  position?: string;
}

const Legend: React.FC<LegendProps> = ({ mix, children, position }) => {
  return (
    <Popup
        trigger={
          <div className={cn("legend__trigger")(null, [mix])}>
            <Info />
          </div>
        }
        position={position === "left" ? "bottom left" : "bottom right"}
        closeOnDocumentClick
        offsetX={position === "left" ? -15 : 16}
        offsetY={5}
        arrowStyle={{
          borderWidth: "0px",
          transform: `translate(${position === "left" ? "15px" : "-16px"})`,
        }}
        contentStyle={{
          borderRadius: "4px",
          top: "50px",
          boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.20)",
          borderWidth: "0px",
          padding: "24px",
          width: "auto",
        }}
      >
        {children}
      </Popup>
  )
};

export default Legend;
